import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import { useSettingsContext } from '../../components/settings';
//
import Main from './Main';
import Header from './header';
import NavMini from './nav/NavMini';
import NavVertical from './nav/NavVertical';
import NavHorizontal from './nav/NavHorizontal';
import { HEADER } from '../../config-global';
import { navLog } from 'src/utils/navDebug';

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const location = useLocation();
  const { themeLayout } = useSettingsContext();
  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    navLog('DashboardLayout location changed', { pathname: location.pathname });
  }, [location.pathname]);

  const [open, setOpen] = useState(false);
  const [searchbarOpen, setSearchbarOpen] = useState(false);

  const isNavHorizontal = themeLayout === 'horizontal';
  const isNavMini = themeLayout === 'mini';

  const handleOpen = () => { setOpen(true) };
  const handleClose = () => { setOpen(false) };

  const handleSearchbarOpen = () => {
    setSearchbarOpen(true);
  };
  const handleSearchbarClose = () => {
    setSearchbarOpen(false);
  };

  const renderNavVertical = <NavVertical openNav={open} onCloseNav={handleClose} />;

  if (isNavHorizontal) {
    return (
      <>
        <Header
          onOpenNav={handleOpen}
          onOpenSearchbar={handleSearchbarOpen}
          onCloseSearchBar={handleSearchbarClose}
          isSearchbarOpen={searchbarOpen}
        />
        {isDesktop ? <NavHorizontal /> : renderNavVertical}

        <Main>
          <Outlet
            context={{ isSearchbarOpen: searchbarOpen, onSearchbarClose: handleSearchbarClose }}
          />
        </Main>
      </>
    );
  }

  if (isNavMini) {
    return (
      <>
        <Header
          onOpenNav={handleOpen}
          onOpenSearchbar={handleSearchbarOpen}
          onCloseSearchBar={handleSearchbarClose}
          isSearchbarOpen={searchbarOpen}
        />

        <Box
          sx={{
            display: 'flex',
            minHeight: 1,
            maxHeight: `calc(100% - ${HEADER.H_DASHBOARD_DESKTOP}px)`,
          }}
        >
          {isDesktop ? <NavMini /> : renderNavVertical}

          <Main>
            <Outlet
              context={{ isSearchbarOpen: searchbarOpen, onSearchbarClose: handleSearchbarClose }}
            />
          </Main>
        </Box>
      </>
    );
  }

  return (
    <>
      <Header
        onOpenNav={handleOpen}
        onOpenSearchbar={handleSearchbarOpen}
        onCloseSearchBar={handleSearchbarClose}
        isSearchbarOpen={searchbarOpen}
      />

      <Box
        sx={{
          display: 'flex',
          minHeight: 1,
          maxHeight: `calc(100% - ${HEADER.H_DASHBOARD_DESKTOP}px)`,
        }}
      >
        {renderNavVertical}

        <Main>
          <Outlet
            context={{ isSearchbarOpen: searchbarOpen, onSearchbarClose: handleSearchbarClose }}
          />
        </Main>
      </Box>
    </>
  );
}
